export default "__VITE_ASSET__Dqm7aUJk__"